module.exports = __webpack_public_path__ + "static/media/icon-group.7f1e56cf.svg";